import { Component } from '@angular/core';

@Component({
  selector: 'app-join-us',
  standalone: true,
  imports: [],
  templateUrl: './join-us.component.html',
  styleUrl: './join-us.component.scss'
})
export class JoinUsComponent {

}
